import { GetResultEmployeesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useResultEmployees = (policyPeriodId: number) => {
  const { data, error, loading, networkStatus } = useQuery(GetResultEmployeesDocument, {
    variables: { policyPeriodId },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  })

  const employeeIds =
    data?.payroll.employeeResultsSummaries?.map((summary) => summary.employeeId) ?? []

  return {
    loading,
    networkStatus,
    error,
    employeeIds,
  }
}
